<template>
<div class="brain-page" v-if="isSmallScreen===false" >
<headers :imageSrc="imageSrc"/>
<mains :res1="res1" :res2="res2" :res3="res3" :res4="res4" :res5="res5"/>
<bottom/>
</div>
<div class="brain-page" v-else >
<headers :imageSrc="imageSrc"/>
<brain-mains :res1="res1" :res2="res2" :res3="res3" :res4="res4" :res5="res5"/>
<brain-foot/>
</div>
</template>
<script>
import headers from '../../components/headers.vue'
import Mains from '../../components/mains.vue'
import bottom from '@/components/bottom'
import BrainMains from '../../components/brainMains.vue'
import BrainFoot from '../../components/brainFoot.vue'
export default {
  components: { headers, Mains, bottom, BrainMains, BrainFoot },
  data () {
    return {
      isSmallScreen: false,
      imageSrc: '../assets/image/tlf_csltdnbanner.png',
      res1: '碳立方-城市零碳大脑',
      res2: '政府管理：为全省各政府完成 “双碳” 目标提供有力数据支持；为生态环境监管部门监管碳市场提供信息化支撑；业务流程信息化，节约人力，物力。企业服务：帮助企业能够全在线 “一站 ',
      res3: '式” 管理碳资产，实现碳履约，促进碳减排，方便碳交易，寻求碳帮助。',
      res4: '某能源城市零碳大脑',
      res5: '../assets/2023logoImage/tlf_csltdn.png'
    }
  },
  mounted () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      this.imageSrc = '../assets/image/csltdnbanner.png'
    } else {
      this.isSmallScreen = false
    }
  },
  created () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      this.imageSrc = '../assets/image/csltdnbanner.png'
    } else {
      this.isSmallScreen = false
    }
  }
}
</script>

<style scoped>

</style>
